(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-choice-button/assets/javascripts/coupon-choice-link.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-choice-button/assets/javascripts/coupon-choice-link.js');
"use strict";


const {
  ReactIcon
} = svs.ui;
const {
  TipsenLink
} = svs.components.tipsen.tipsen_link;
const {
  clx
} = svs.components.lbUtils;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  getProductBrandByDraw
} = svs.components.lbUtils.brandMapping.fn;
const CouponChoiceLink = _ref => {
  let {
    ariaLabel,
    children,
    className,
    icon,
    to = {}
  } = _ref;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';

  return React.createElement(TipsenLink, {
    "aria-label": ariaLabel,
    className: clx('coupon-toolbox-guide-button btn btn-300 btn-coupon-choice btn-default', className, {
      ["btn-coupon-choice-branding-".concat(branding)]: branding
    }),
    title: ariaLabel,
    to: to
  }, React.createElement("span", {
    className: "btn-link-text"
  }, React.createElement(ReactIcon, {
    icon: icon,
    size: isSmall ? 200 : 300
  }), React.createElement("span", {
    className: "btn-text"
  }, children)));
};
setGlobal('svs.components.tipsen.couponChoiceButton.CouponChoiceLink', CouponChoiceLink);

 })(window);